<template>
  <div class="create-note-modal">
    <div class="modal-overlay" @click="$emit('close')"></div>
    <div class="modal-content">
      <div class="modal-handle"></div>
      
      <div class="modal-header">
        <h3>New notes</h3>
      </div>
      
      <div class="options-list">
        <div
          v-for="option in createOptions"
          :key="option.type"
          class="option-item"
          @click="selectOption(option)"
        >
          <div class="option-icon" :class="`icon-${option.type}`">
            <i>{{ option.icon }}</i>
          </div>
          <div class="option-content">
            <h4>{{ option.title }}</h4>
            <p>{{ option.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateNoteModal',
  emits: ['close', 'selectOption'],
  data() {
    return {
      createOptions: [
        {
          type: 'record',
          icon: '🎤',
          title: 'Record Audio',
          description: 'Start live recording'
        },
        {
          type: 'import',
          icon: '🎵',
          title: 'Import Audio',
          description: 'Upload audio file'
        },
        {
          type: 'camera',
          icon: '📷',
          title: 'Take Picture',
          description: 'Capture from camera'
        },
        {
          type: 'pdf',
          icon: '📄',
          title: 'Upload PDF',
          description: 'Import document'
        },
        {
          type: 'youtube',
          icon: '📹',
          title: 'Use YouTube Video',
          description: 'From YouTube link'
        }
      ]
    }
  },
  methods: {
    selectOption(option) {
      this.$emit('selectOption', option)
    }
  }
}
</script>

<style lang="less" scoped>
.create-note-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  
  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
  }
  
  .modal-content {
    position: relative;
    width: 100%;
    max-height: 70vh;
    background: white;
    border-radius: 24px 24px 0 0;
    box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.15);
    animation: modalSlideUp 0.3s ease-out;
    padding-bottom: env(safe-area-inset-bottom, 0);
  }
  
  .modal-handle {
    width: 40px;
    height: 4px;
    background: #d1d5db;
    border-radius: 2px;
    margin: 12px auto 0;
  }
  
  .modal-header {
    text-align: center;
    padding: 20px 24px 16px;
    
    h3 {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #111827;
    }
  }
  
  .options-list {
    padding: 0 16px 24px;
    
    .option-item {
      display: flex;
      align-items: center;
      padding: 20px;
      margin-bottom: 12px;
      background: #f9fafb;
      border-radius: 16px;
      cursor: pointer;
      transition: all 0.2s ease;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      &:active {
        background: #f3f4f6;
        transform: scale(0.98);
      }
      
      .option-icon {
        width: 56px;
        height: 56px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
        
        &.icon-record {
          background: linear-gradient(135deg, #10b981, #059669);
        }
        
        &.icon-import {
          background: linear-gradient(135deg, #3b82f6, #1d4ed8);
        }
        
        &.icon-camera {
          background: linear-gradient(135deg, #f59e0b, #d97706);
        }
        
        &.icon-pdf {
          background: linear-gradient(135deg, #8b5cf6, #7c3aed);
        }
        
        &.icon-youtube {
          background: linear-gradient(135deg, #ef4444, #dc2626);
        }
        
        i {
          font-size: 28px;
          filter: brightness(1.2);
        }
      }
      
      .option-content {
        flex: 1;
        
        h4 {
          margin: 0 0 4px 0;
          font-size: 18px;
          font-weight: 600;
          color: #111827;
        }
        
        p {
          margin: 0;
          font-size: 14px;
          color: #6b7280;
        }
      }
    }
  }
}

@keyframes modalSlideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
</style> 